import {
  formatDateString,
  formatRelativeDateString,
} from "@/v2-common/utils/utils.date"
import Tooltip from "@/v2-ui/tooltip"

export type RelativeDateProps = {
  date: Date | string | null | undefined
}

function RelativeDate(props: RelativeDateProps) {
  const { date } = props
  if (!date) return null

  const relative = formatRelativeDateString(date)
  const full = formatDateString(date)

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <span className="relative-date">{relative}</span>
      </Tooltip.Trigger>
      <Tooltip.Content side="top">{full}</Tooltip.Content>
    </Tooltip>
  )
}

export default RelativeDate
